import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import VueDragVerify from 'vue-drag-verify'
import '@/styles/theme.scss'
import 'element-ui/lib/theme-chalk/icon.css'

Vue.use(ElementUI)
Vue.use(VueDragVerify)
// console.log("store",store)

// 应用启动时初始化权限
if (store.getters['isAuthenticated']) {
  store.commit('initPermissions');
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')